<script>
    import { onMount } from 'svelte';
    import { loadHeaderFooter } from '../utils/loadHeaderFooter.js';

    onMount(async () => {
        const headerElement = document.getElementById('dual-brand-header');
        loadHeaderFooter(headerElement);
    });
</script>

<nav id="banner_home">
    <img
        class="dual_brand_logo"
        src="/disruptions/dual-brand-logo-lockup.svg"
        alt="Alaska and Hawaiian Airlines Logo"
    />
</nav>

<style>
    #banner_home {
        text-align: center;
        padding: 6px 6px;
        background: var(--ds-basic-color-page-background-default);
        background-size: contain;
        border-bottom: 1px solid var(--ds-basic-color-border-subtle);
        box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.05);
        margin-bottom: 1rem;
    }

    .dual_brand_logo {
        height: 32px;
        position: relative;
        padding: 8px;
    }
</style>
